import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCoupons$dInternal$dTypes$dCouponData from "../Restaumatic.Coupons.Internal.Types.CouponData/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const UserLoyalty = x => x;
const newtypeUserLoyalty_ = {Coercible0: () => {}};
const hasFieldUserLoyalty = dictHasField => dictHasField;
const eqUserLoyalty = {
  eq: x => y => x.count === y.count && Data$dMap$dInternal.eqMap(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.eqCouponData)(Data$dEq.eqUnit).eq(x.couponData)(y.couponData) && x.promotionName === y.promotionName
};
const genericUserLoyalty = {to: x => x, from: x => x};
const showUserLoyalty = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.showCouponData);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["count", Data$dShow.showIntImpl(v.count)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "couponData",
              $0.show(v.couponData)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["promotionName", Data$dShow.showStringImpl(v.promotionName)]))([])));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "UserLoyalty"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeUserLoyalty = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "count"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "couponData"
    })(Unscramble.decodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.unscrambleDecodeCouponData)(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.ordCouponData))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "promotionName"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeUserLoyalty = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericUserLoyalty)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UserLoyalty"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "promotionName"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "couponData"})((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.encodeCouponData);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "count"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeUserLoyalty = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericUserLoyalty)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "UserLoyalty"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "promotionName"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "couponData"})(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.ordCouponData)(Restaumatic$dCoupons$dInternal$dTypes$dCouponData.decodeCouponData);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "count"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  UserLoyalty,
  decodeUserLoyalty,
  encodeUserLoyalty,
  eqUserLoyalty,
  genericUserLoyalty,
  hasFieldUserLoyalty,
  newtypeUserLoyalty_,
  showUserLoyalty,
  unscrambleDecodeUserLoyalty
};
